<template>
    <div class="cropper">
         <img v-show="isshowshowimg" :src="img" class="showimg" />
      <!-- option是配置，格式是对象，getbase64Data是组件的一个方法获取裁剪完的头像 2.14新增一个获取getblobData的方法 -->
      <h5-cropper class="uploadinput"
        :option="option"
        @getbase64Data="getbase64Data"
      ></h5-cropper>
    </div>

   
</template>
<script>
//            <fileupload style="width:30%;height:5rem;position:absolute;left:20%;top:10%;" fixedNumber=[1,1] ref="fileupload"></fileupload>
import { mapState} from 'vuex'
export default {
  name: 'fileupload',
  props: ["fixedNumber"],
  data() {
    return {
      "option": {"fixedNumber":JSON.parse(this.fixedNumber)}, //配置
      "img":'',
      "isshowshowimg":0
  
   
 
    }
  },
  mounted() {
 
  },
  methods: {
  


   getbase64Data(data) {
      this.isshowshowimg=1;
      this.img = data;
    }



  
  },
  computed: {
    ...mapState(['suodingtipcss', 'yujiazaicss', 'sharetipcontainercss', 'morentanchuangcss', 'chuangtitle', 'fn', 'jindu', 'starcss', 'isalljiazai']),
  }
}

</script>
<style scoped>
.showimg{
  width: 100%;
  height: 100%;
  position: absolute;
  left:0px;
  top:0px;
}
.uploadinput{
    width: 100%;
  height: 100%;
  position: absolute;
  left:0px;
  top:0px;
}
</style>


// WEBPACK FOOTER //
// src/components/fileupload.vue